export default {
  Button: {
    RequestSubmit: 'Yêu cầu nộp',
    AcceptRevoke: 'Phê duyệt yêu cầu thu hồi',
    CreateExamineForm: 'Tạo biên bản kiểm tra',
  },
};
